import {
  createCheckAuthorization,
  resolveAuthState,
  validateReverificationConfig
} from "./chunk-37B446K4.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  createCheckAuthorization,
  resolveAuthState,
  validateReverificationConfig
};
//# sourceMappingURL=authorization.mjs.map